async function* countDownAsync(duration: number, onFinished?: () => void) {
  let currentDuration = duration;
  while (currentDuration > 0) {
    yield (currentDuration -= 1);
    /* eslint-disable */
    await new Promise(r => setTimeout(r, 1000));
    /* eslint-enable */
  }
  onFinished?.();
}

export default countDownAsync;
